import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { requestoauthApi } from "../../../../../services/authApi"
import Divider from '@mui/material/Divider';


export default function SetGmail({ authUserinfo }) {
  const registerGmailClick = async () => {
    try {
      const response = await requestoauthApi({ action: "getgmail" })
      window.location.href = response["data"]["url"]
    } catch (error) {
      console.log("HavvveErrror")
    }
  }
  return (
    <Paper sx={{ mr: 2, p: 1, pt: 3 }}>
      {authUserinfo["email"] ? <>
        <Typography>آدرس ایمیل شما ثبت شده است، شما می توانید با آدرس ایمیل یا کلمه عبور و یا مستقیما از طریق ایمیل خود وارد سایت شوید</Typography>
        <Divider sx={{ my: 1 }}></Divider>
        <Typography>{`آدرس ایمیل : ${authUserinfo["email"]}`}</Typography>
      </> : <>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={registerGmailClick}
        >
          ثبت Gmail
        </Button>
        <Typography>شما می توانید با ثبت آدرس جیمیل خود از این به بعد با آدرس ایمیل یا کلمه عبور و یا مستقیما از طریق ایمیل خود وارد سایت شوید</Typography>
      </>}
    </Paper>
  );
}
